// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6361":"dcc5645d1b6310ab","8587":"c6e934720c7a5814"}[chunkId] + ".css";
};